"use client";

import { c as _c } from "react/compiler-runtime";
import { AnnouncementBar, announcementBarTextClassName } from "@/components/announcement-bar";
import { useSelfScheduleUrlPrefillBanner } from "@/contexts/self-schedule-provider";
export const UrlPrefillContextBanner = () => {
  const $ = _c(2);
  const message = useSelfScheduleUrlPrefillBanner();
  if (!message) {
    return null;
  }
  let t0;
  if ($[0] !== message) {
    t0 = <AnnouncementBar aria-label="Booking link details"><p role="status" aria-live="polite" className={announcementBarTextClassName}>{message}</p></AnnouncementBar>;
    $[0] = message;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};